export const GENERATION_SEED_MIN = 1;
export const GENERATION_SEED_MAX = 2147483647;

export const randomGenerationSeed = () => {
  const range = GENERATION_SEED_MAX - GENERATION_SEED_MIN + 1;
  const buf = new Uint32Array(1);
  crypto.getRandomValues(buf);
  return GENERATION_SEED_MIN + (buf[0] % range);
};

export const parseGenerationSeed = (value) => {
  if (typeof value === 'number' && Number.isInteger(value)) {
    if (value < GENERATION_SEED_MIN || value > GENERATION_SEED_MAX) return null;
    return value;
  }
  const raw = String(value ?? '').trim();
  if (!/^\d+$/.test(raw)) return null;
  const parsed = Number(raw);
  if (!Number.isSafeInteger(parsed)) return null;
  if (parsed < GENERATION_SEED_MIN || parsed > GENERATION_SEED_MAX) return null;
  return parsed;
};

export const bindGenerationSeedControl = ({
  input,
  lockButton,
  rerollButton,
  lockedLabel = 'Keep seed after generation',
  unlockedLabel = 'Randomize seed after generation',
  locked = true,
} = {}) => {
  let isLocked = locked !== false;

  const writeSeed = (seed) => {
    if (!input) return;
    input.value = String(seed);
  };

  const syncLockButton = () => {
    if (!lockButton) return;
    lockButton.setAttribute('aria-pressed', isLocked ? 'true' : 'false');
    lockButton.setAttribute('aria-label', isLocked ? lockedLabel : unlockedLabel);
    const icon = lockButton.querySelector('i');
    if (!icon) return;
    icon.classList.toggle('fa-lock', isLocked);
    icon.classList.toggle('fa-unlock', !isLocked);
  };

  const setLocked = (next) => {
    isLocked = next !== false;
    syncLockButton();
  };

  const reroll = () => writeSeed(randomGenerationSeed());

  if (parseGenerationSeed(input?.value) == null) writeSeed(randomGenerationSeed());
  setLocked(isLocked);

  const handleToggleLock = () => setLocked(!isLocked);
  lockButton?.addEventListener('click', handleToggleLock);
  lockButton?.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    handleToggleLock();
  });

  rerollButton?.addEventListener('click', reroll);
  rerollButton?.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    reroll();
  });

  return {
    readSeed: () => parseGenerationSeed(input?.value),
    isLocked: () => isLocked,
    lock: () => setLocked(true),
    applySeed: (seed) => {
      const parsed = parseGenerationSeed(seed);
      if (parsed == null) return false;
      writeSeed(parsed);
      setLocked(true);
      return true;
    },
    rollAfterQueue: () => {
      if (!isLocked) reroll();
    },
  };
};
